import React from "react";
import { Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ResetPasswordFooter = () => {
  const { t } = useTranslation("account");
  return (
    <Link component={RouterLink} to="/auth" underline="none" variant="body2">
      {t("resetPassword.backToLogin")}
    </Link>
  );
};

export default ResetPasswordFooter;
